import axios from "axios";
import { BACKEND_URL } from "../../config/api";

export type WithdrawalRequestStatus = "PENDING" | "SUCCESS" | "REJECTED" | "CANCELLED";

export interface WithdrawalRequest {
  id: string;
  user_id: string;
  amount: number;
  currency: string;
  fee_amount: number | null;
  total_amount: number | null;
  withdrawal_method: string;
  withdrawal_identifier: string;
  operator: string | null;
  description: string | null;
  status: WithdrawalRequestStatus;
  admin_note: string | null;
  created_at: string;
  updated_at: string;
}

export interface WithdrawalRequestListResponse {
  items: WithdrawalRequest[];
  total: number;
  page: number;
  page_size: number;
}

export const withdrawalRequestService = {
  async listRequests(
    token: string,
    params: { status?: WithdrawalRequestStatus; page?: number; page_size?: number }
  ): Promise<WithdrawalRequestListResponse> {
    const response = await axios.get(`${BACKEND_URL}/withdrawal-request/`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return response.data?.data;
  },

  async updateStatus(
    token: string,
    requestId: string,
    status: WithdrawalRequestStatus,
    adminNote?: string
  ): Promise<WithdrawalRequest> {
    const response = await axios.put(
      `${BACKEND_URL}/withdrawal-request/${requestId}/status`,
      { status, admin_note: adminNote },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data?.data;
  },
};
